function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

//  parse html，inspred by https://zhuanlan.zhihu.com/p/338772106,
// fixed self close tag parse bug.
// fixed including comment parse bug.

var SPACE_REGEX = /\s/;
var TOKEN_REGEX = /[a-zA-Z0-9\-]/;
var DOCTYPE_MARK = '<!DOCTYPE html>';
var COMMENT_START = '<!--';
var COMMENT_END = '-->';
var META_END = '</meta>';
var LINK_END = '</link>';
var MAY_SELF_CLOSE_TAGS = ['meta', 'link'];
var TAG_END_MAP = {
  meta: META_END,
  link: LINK_END
};
var HTMLParser = /*#__PURE__*/function () {
  function HTMLParser() {
    _classCallCheck(this, HTMLParser);
    this.input = '';
    this.len = 0;
    this.cur = 0;
  }
  _createClass(HTMLParser, [{
    key: "eof",
    get: function get() {
      return this.cur >= this.len;
    }
  }, {
    key: "peek",
    value: function peek() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.input[this.cur + offset];
    }
  }, {
    key: "sub",
    value: function sub(len, start) {
      var startIdx = start || this.cur;
      return this.input.substring(startIdx, startIdx + len);
    }
  }, {
    key: "moveCur",
    value: function moveCur(num) {
      this.cur += num;
    }
  }, {
    key: "consumeChar",
    value: function consumeChar(c) {
      var curChar = this.peek();
      if (curChar === c) {
        this.cur++;
      } else {
        throw new Error("Unexpected character: '".concat(curChar, "' should be '").concat(c, "'"));
      }
      return curChar;
    }
  }, {
    key: "consumeSpace",
    value: function consumeSpace() {
      this.consumeWhile(SPACE_REGEX);
    }
  }, {
    key: "consumeWhile",
    value: function consumeWhile(regex) {
      var result = [];
      do {
        var curChar = this.peek();
        if (regex.test(curChar)) {
          result.push(curChar);
          this.cur++;
        } else {
          break;
        }
      } while (!this.eof);
      return result.join('');
    }
  }, {
    key: "noop",
    value: function noop() {}
  }, {
    key: "pureInput",
    value: function pureInput( /** @type string */input) {
      var puredStr = input.trim();
      if (puredStr.startsWith(DOCTYPE_MARK)) {
        puredStr = puredStr.substring(DOCTYPE_MARK.length);
      }

      // 移除 <!-- --> 相关的注释
      var delComment = function delComment(str) {
        var commentStartIdx = str.indexOf(COMMENT_START);
        var commentEndIdx = str.indexOf(COMMENT_END);
        if (commentStartIdx >= 0 && commentEndIdx >= 0) {
          var strBeforeComment = str.substring(0, commentStartIdx);
          var strAfterComment = str.substring(commentEndIdx + COMMENT_END.length);
          return delComment("".concat(strBeforeComment).concat(strAfterComment));
        }
        return str;
      };
      puredStr = delComment(puredStr);
      return puredStr;
    }
  }, {
    key: "parse",
    value: function parse(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var inputStr = input || '';
      this.input = this.pureInput(inputStr);
      this.len = inputStr.length;
      this.onTagOpen = options.onTagOpen || this.noop();
      this.onTagClose = options.onTagClose || this.noop();
      this.cur = 0;
      return this.parseNodes();
    }
  }, {
    key: "parseNodes",
    value: function parseNodes() {
      var nodes = [];
      do {
        var node = void 0;
        if (this.peek() === '<') {
          if (this.peek(1) === '/') break;
          node = this.parseElement();
        } else {
          node = this.parseTextNode();
        }
        if (node === ' ') {
          // filter ' ' node
          continue;
        }
        nodes.push(node);
      } while (!this.eof);
      return nodes;
    }
  }, {
    key: "parseTextNode",
    value: function parseTextNode() {
      var text = this.consumeWhile(/[^<]/);
      return text.replace(/[\s\n]+/g, ' ');
    }
  }, {
    key: "parseElement",
    value: function parseElement() {
      var _this = this;
      this.consumeChar('<');
      var tag = this.parseTag();
      this.onTagOpen(tag);
      this.consumeSpace();
      var attrs = this.parseAttrs();
      var curChar = this.peek();
      var curPrev1Char = this.peek(-1);
      var handleTagEnd = function handleTagEnd(children) {
        var move = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        //  const closeTag = this.parseTag();
        _this.parseTag();
        _this.consumeSpace();
        _this.consumeChar('>');
        if (move) {
          _this.moveCur(move);
        }
        var toReturn = {
          tag: tag,
          attrs: attrs,
          children: children
        };
        _this.onTagClose(tag, toReturn);
        return toReturn;
      };
      if ("".concat(curPrev1Char).concat(curChar) === '/>') {
        // is self close tag
        return handleTagEnd([]);
      }
      if (MAY_SELF_CLOSE_TAGS.includes(tag) && curChar === '>') {
        // handle <meta> or <meta></meta>, <link> or <link></link>
        var endTag = TAG_END_MAP[tag];
        var endTagLen = endTag.length;
        var endFeature = this.sub(endTagLen, this.cur + 1);
        var move = endFeature === endTag ? endTagLen : 0;
        return handleTagEnd([], move);
      }
      this.consumeChar('>');
      var children = this.parseNodes();
      this.consumeChar('<');
      this.consumeChar('/');
      return handleTagEnd(children);
    }
  }, {
    key: "parseTag",
    value: function parseTag() {
      var tag = this.consumeWhile(TOKEN_REGEX);
      return tag;
    }
  }, {
    key: "parseAttrs",
    value: function parseAttrs() {
      var attrs = {};
      while (this.peek() !== '>') {
        var name = this.parseTag();
        if (!name) {
          this.consumeChar(this.peek());
          continue;
        }
        if (this.peek() === '=') {
          this.consumeChar('=');
          this.consumeChar('"');
          var value = this.consumeWhile(/[^"]/);
          this.consumeChar('"');
          attrs[name] = value;
        } else {
          attrs[name] = '';
        }
        this.consumeSpace();
      }
      return attrs;
    }
  }]);
  return HTMLParser;
}();
function parseHtml(html, options) {
  var parser = new HTMLParser();
  var result = parser.parse(html, options);
  return result;
}

var index = {
  parseHtml: parseHtml,
  HTMLParser: HTMLParser
};

export { HTMLParser, index as default, parseHtml };
